var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0058 5.48319L10.1235 2.0562C9.73769 1.83141 9.26231 1.83141 8.87646 2.0562L2.99415 5.48319C2.60831 5.70799 2.37061 6.12342 2.37061 6.573V13.427C2.37061 13.8766 2.60831 14.292 2.99415 14.5168L8.87646 17.9438C9.26231 18.1686 9.73769 18.1686 10.1235 17.9438L16.0058 14.5168C16.3917 14.292 16.6294 13.8766 16.6294 13.427V6.573C16.6294 6.12342 16.3917 5.70799 16.0058 5.48319ZM11.0588 0.421485C10.0942 -0.140495 8.90577 -0.140495 7.94115 0.421485L2.05885 3.84848C1.09423 4.41046 0.5 5.44904 0.5 6.573V13.427C0.5 14.551 1.09423 15.5895 2.05885 16.1515L7.94115 19.5785C8.90577 20.1405 10.0942 20.1405 11.0588 19.5785L16.9412 16.1515C17.9058 15.5895 18.5 14.551 18.5 13.427V6.573C18.5 5.44904 17.9058 4.41046 16.9412 3.84848L11.0588 0.421485Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41202 14.9998C9.9141 14.9998 10.3211 14.5928 10.3211 14.0907C10.3211 13.5887 9.9141 13.1816 9.41202 13.1816C8.90994 13.1816 8.50293 13.5887 8.50293 14.0907C8.50293 14.5928 8.90994 14.9998 9.41202 14.9998Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40909 5C7.80502 5 6.5 6.30502 6.5 7.90909C6.5 8.31076 6.8256 8.63636 7.22727 8.63636C7.62895 8.63636 7.95455 8.31076 7.95455 7.90909C7.95455 7.10705 8.60705 6.45455 9.40909 6.45455C10.2111 6.45455 10.8636 7.10705 10.8636 7.90909C10.8636 8.71113 10.2111 9.36364 9.40909 9.36364C9.00742 9.36364 8.68182 9.68924 8.68182 10.0909V11.9091C8.68182 12.3108 9.00742 12.6364 9.40909 12.6364C9.81076 12.6364 10.1364 12.3108 10.1364 11.9091V10.7261C11.3897 10.4024 12.3182 9.26214 12.3182 7.90909C12.3182 6.30502 11.0132 5 9.40909 5Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info-filled.19d1f8325f8bc89ea1aacfe5b756cfad.svg";